import { createAction, props } from '@ngrx/store';
import {Theme} from "./theme.model";

export const updateTheme = createAction(
  '[Update] Theme',
  props<{theme:Theme}>()
);

